import { useState, useRef, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchExperienceTripsDtl } from "../services/ExperienceTripsDtl";
import { fetchGroupdescriptions } from "../services/GrouptripsDtlbannersec";
import { API_BASE } from "../api/apiConfig";

const CommonSection = () => {

  const { id } = useParams();
  const [ExperienceTripsDtldata, setExperienceTripsDtldata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [GroupTripsdetail, setGroupTripsdec] = useState(null);
  const [GroupTripsdetailall, setGroupTripsdecall] = useState(null);
  const [allStayData, setAllStayData] = useState([]);
  const [hlightsData, setAllhlightsData] = useState([]);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchExperienceTripsDtl(decodeURIComponent(id));

      if (res?.data) {
         setExperienceTripsDtldata(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);


  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGroupdescriptions(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setGroupTripsdec(res.data[0]);
      }
      console.log("FULL API RESPONSE:", res);
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGroupdescriptions(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setGroupTripsdecall(res.data);
      }

      if (res?.status && res?.allstaydata?.length > 0) {
        setAllStayData(res.allstaydata);
      }

      if (res?.status && res?.allhighlightsdata?.length > 0) {
        setAllhlightsData(res.allhighlightsdata);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);




  const ReadMoreText = ({ text, className }) => {
    const [expanded, setExpanded] = useState(false);
    const [showToggle, setShowToggle] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
      if (textRef.current) {
        setShowToggle(textRef.current.scrollHeight > textRef.current.clientHeight);
      }
    }, []);

    return (
      <div>
        <p
          ref={textRef}
          className={`${className} ${expanded ? "" : "line-clamp-2"}`}
        >
          {text}
        </p>
        {showToggle && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-1 text-xs font-medium text-primary hover:underline"
          >
            {expanded ? "Read less" : "Read more"}
          </button>
        )}
      </div>
    );
  };

  const [openDay, setOpenDay] = useState(1);

  const days = [
    {
       day: 1,
      title: "Arrival in Leh",
      image: "assets/images/leh-arrival.jpg",
      tags: ["Airport pickup", "Acclimatization"],
      description:
        "Arrive at Leh Airport (11,500 ft). Rest and acclimatize. Evening orientation and welcome dinner at a traditional Ladakhi home.",
      meals: "Dinner",
      stay: "Heritage Hotel in Leh",
    },
    {
       day: 2,
      title: "Leh Exploration",
      image: "assets/images/leh-palace.jpg",
      tags: ["Leh Palace", "Shanti Stupa"],
      description:
        "Explore Leh Palace, Shanti Stupa and local markets.",
      meals: "Breakfast, Lunch, Dinner",
      stay: "Heritage Hotel in Leh",
    },
    {
      day: 3,
      title: "Leh to Nubra Valley",
      image: "assets/images/nubra-valley-dunes.jpg",
      tags: ["Khardung La", "Nubra Valley"],
      description: "Cross the legendary Khardung La Pass (18,380 ft). Descend into Nubra Valley. Evening camel safari on the white sand dunes of Hunder.",
      meals: "Breakfast, Lunch, Dinner",
      stay: "Luxury Tents in Hunder",
    },
    {
      day: 4,
      title: "Nubra Valley to Turtuk",
      image: "assets/images/turtuk-village.jpg",
      tags: ["Turtuk Village", "Balti Culture"],
      description:
        "Drive to Turtuk - India's last village before Pakistan. Experience Balti culture, apricot orchards, and stunning mountain scenery.",
      meals: "Breakfast, Lunch, Dinner",
      stay: "Homestay in Turtuk",
    },
    {
      day: 5,
      title: "Turtuk to Pangong Lake",
      image: "assets/images/pangong-lake-camping.jpg",
      tags: ["Scenic Drive", "Pangong Lake"],
      description: "Long scenic drive to Pangong Lake via Shyok route. Arrive at the lake by evening. Camp by the shores under millions of stars.",
      meals: "Breakfast, Lunch, Dinner",
      stay: "Lakeside Camps at Pangong",
    },
    {
      day: 6,
      title: "Pangong Lake",
      image: "assets/images/pangong-sunrise.jpg",
      tags: ["Sunrise", "Spangmik"],
      description: "Sunrise at Pangong. Explore the changing colors of the lake. Visit Spangmik village. Afternoon photography session and leisure.",
      meals: "Breakfast, Lunch, Dinner",
      stay: "Lakeside Camps at Pangong",
    },
    {
      day: 7,
      title: "Pangong to Leh",
      image: "assets/images/hemis-monastery.jpg",
      tags: ["Chang La", "Hemis Monastery"],
      description:"Return to Leh via Chang La Pass. Stop at Hemis and Thiksey monasteries. Farewell dinner with the group.",
      meals: "Breakfast, Lunch, Dinner",
      stay: "Heritage Hotel in Leh",
    },
    {
      day: 8,
      title: "Departure",
      image: "assets/images/leh-departure.jpg",
      tags: ["Airport Transfer"],
      description: "Airport transfer and departure.",
      meals: "Breakfast",
      stay: "",
    },
  ];

  const filteredMeetups = days;

  // Split covered_place into array of inclusion
  const inclusion = GroupTripsdetail?.inclusion
    ? GroupTripsdetail.inclusion
        .split("@@")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];

  // Split covered_place into array of exclusion
  const exclusion = GroupTripsdetail?.exclusion
    ? GroupTripsdetail.exclusion
        .split("@@")
        .map((exclusiondata) => exclusiondata.trim())
        .filter(Boolean)
    : [];

  // Split covered_place into array of destinations
  const destinations = ExperienceTripsDtldata?.covered_place
    ? ExperienceTripsDtldata.covered_place
        .split(",")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];

// Meals count logic
const mealsCount = { Breakfast: 0, Lunch: 0, Dinner: 0 };

if (Array.isArray(GroupTripsdetailall)) {
  GroupTripsdetailall.forEach((item) => {
    if (item?.mealslace) {
      item.mealslace.split("@").forEach((meal) => {
        const m = meal.trim().toLowerCase();

        if (m === "breakfast") mealsCount.Breakfast += 1;
        if (m === "lunch") mealsCount.Lunch += 1;
        if (m === "dinner") mealsCount.Dinner += 1;
      });
    }
  });
}

const meals = [
  { name: "Breakfast", count: mealsCount.Breakfast },
  { name: "Lunch", count: mealsCount.Lunch },
  { name: "Dinner", count: mealsCount.Dinner },
];

const stays = Array.isArray(allStayData) ? allStayData : [];
const triphighlightdata = Array.isArray(hlightsData) ? hlightsData : [];

const Itinerarydata = Array.isArray(GroupTripsdetailall)
  ? GroupTripsdetailall.map((item, index) => ({
      day: index + 1,
      title: item.coveredplace || "N/A",
      description: item.descriptionplace || "",
      image: item.imageplace
        ? `${API_BASE}public/${item.imageplace}`
        : `${API_BASE}public/default.jpg`,
      meals: item.mealslace ? item.mealslace.replace(/@/g, ", ") : "No meals",
      stay: item.stayplace || "No stay",
      tags: item.mealslace ? item.mealslace.split("@") : [],
    }))
  : [];

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!ExperienceTripsDtldata) return <p className="text-center py-10">No Data found</p>;

  return (
    <>
      {/* Main container */}
      <div className="container py-5 common-section">
        {/* Header */}
        <div className="lg:flex lg:gap-16 min-w-0">
          <div className="lg:flex-1 space-y-6 md:space-y-12 min-w-0">
            <section>
              <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6">
                Trip Details
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
                <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-primary/20 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-map-pin h-4 w-4 md:h-5 md:w-5 text-primary"
                      >
                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                        <circle cx={12} cy={10} r={3} />
                      </svg>
                    </div>
                    <h3 className="font-semibold text-slate-900 text-sm md:text-base">
                      Destinations
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-1.5 md:gap-2">
                  {destinations.map((destinationsval, index) => (
                      <span key={index} className="bg-white/80 text-slate-700 text-xs md:text-sm px-2 md:px-3 py-0.5 md:py-1 rounded-full">
                        {destinationsval}
                      </span>
                  ))}
                  </div>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-orange-200/50 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-utensils h-4 w-4 md:h-5 md:w-5 text-orange-600"
                      >
                        <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                        <path d="M7 2v20" />
                        <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                      </svg>
                    </div>
                    <h3 className="font-semibold text-slate-900 text-sm md:text-base">
                      Meals Included
                    </h3>
                  </div>
                  <div className="grid grid-cols-3 gap-1.5 md:gap-2 text-center">
                  {meals.map((meal, index) => (
                    <div key={index} className="bg-white/80 rounded-lg md:rounded-xl p-1.5 md:p-2">
                      <p className="text-base md:text-xl font-bold text-orange-600">
                        {meal.count}
                      </p>
                      <p className="text-[10px] md:text-xs text-slate-500">
                        {meal.name}
                      </p>
                    </div>
                  ))}
                  </div>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-blue-200/50 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-home h-4 w-4 md:h-5 md:w-5 text-blue-600"
                      >
                        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        <polyline points="9 22 9 12 15 12 15 22" />
                      </svg>
                    </div>
                    <h3 className="font-semibold text-slate-900 text-sm md:text-base">
                      Stay Types
                    </h3>
                  </div>
                  <div className="space-y-1.5 md:space-y-2">
                    <div
                        className="space-y-1.5 md:space-y-2 [&_ul]:list-disc [&_ul]:pl-5"
                        dangerouslySetInnerHTML={{
                          __html: ExperienceTripsDtldata.staytypes || "No available information"
                        }}
                      />
                  </div>
                </div>
              </div>
            </section>
          
            <section className="min-w-0">
              <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6">
                Where You'll Stay
              </h2>

              {/* ---------- MOBILE ---------- */}
              <div className="md:hidden scrollbar-custom pb-1">
                <div className="inline-flex gap-3">
                  {stays.map((item, index) => (
                    <div
                      key={index}
                      className="w-56 flex-shrink-0 bg-white border border-slate-200 rounded-xl overflow-hidden"
                    >
                      <div className="relative h-32">
                        <img
                          src={`${API_BASE}/public/${item?.stay_image}`}
                          alt={item.stay_title}
                          className="absolute inset-0 w-full h-full object-cover"
                        />
                      </div>
                      <div className="p-3">
                        <h3 className="font-bold text-slate-900 text-sm mb-1">
                          {item.stay_title}
                        </h3>
                        <ReadMoreText
                          text={item.stay_description
                            ?.replace(/<[^>]+>/g, "")
                            .replace(/&nbsp;/g, " ")
                            .replace(/&#39;/g, "'")
                            .replace(/&amp;/g, "&")
                            .replace(/&quot;/g, '"')
                            .replace(/\s+/g, " ")
                          }
                          className="text-xs text-slate-600"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ---------- DESKTOP ---------- */}
              <div className="hidden md:grid md:grid-cols-2 md:gap-5">
                {stays.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white border border-slate-200 rounded-xl overflow-hidden"
                  >
                    <div className="relative h-44">
                      <img
                        src={`${API_BASE}/public/${item?.stay_image}`}
                        alt={item.stay_title}
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-bold text-slate-900 text-base mb-1">
                        {item.stay_title}
                      </h3>
                      <ReadMoreText
                        text={item.stay_description
                          ?.replace(/<[^>]+>/g, "")
                          .replace(/&nbsp;/g, " ")
                          .replace(/&#39;/g, "'")
                          .replace(/&amp;/g, "&")
                          .replace(/&quot;/g, '"')
                          .replace(/\s+/g, " ")
                        }
                        className="text-sm text-slate-600"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </section>
          
            <section className="min-w-0">
              <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6">
                Trip Highlights
              </h2>
              <div className="md:hidden overflow-x-auto scrollbar-hide pb-1">
                <div className="inline-flex gap-3">
                  {triphighlightdata.map((itemval, index) => (
                    <div key={index} className="relative w-44 h-56 flex-shrink-0 rounded-xl overflow-hidden">
                      <img
                        src={`${API_BASE}/public/${itemval?.trip_image}`}
                        alt="Highlight"
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                      <div className="absolute bottom-0 left-0 right-0 p-3">
                        <p className="text-white font-semibold text-sm leading-snug line-clamp-2">
                          {itemval.trip_title}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="hidden md:grid md:grid-cols-3 gap-4">
                {triphighlightdata.map((itemval, index) => (
                  <div key={index} className="group relative aspect-[4/3] rounded-2xl overflow-hidden">
                    <img
                      src={`${API_BASE}/public/${itemval?.trip_image}`}
                      alt="Highlight"
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <p className="text-white font-semibold text-sm leading-snug line-clamp-2">
                        {itemval.trip_title}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* "Day-by-Day Itinerary" Section */}
            <section className="max-w-6xl mx-auto py-5">
              <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-6">
                Day-by-Day Itinerary
              </h2>
              <div className="space-y-4 md:space-y-6">
                {Itinerarydata.map((item) => {
                  const isOpen = openDay === item.day;
                  return (
                    <div key={item.day} className="group">
                      <div className="bg-white border border-slate-200 rounded-2xl md:rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-lg">
                        {/* HEADER */}
                        <button
                          onClick={() =>
                            setOpenDay(isOpen ? null : item.day)
                          }
                          className="w-full flex items-stretch text-left"
                        >
                          <div className="relative w-24 sm:w-32 md:w-48 flex-shrink-0 hidden sm:block overflow-hidden">
                            <img
                              src={item.image}
                              alt={item.title}
                              className="absolute inset-0 w-full h-full object-cover"
                            />
                          </div>
                          {/* Content */}
                          <div className="flex-1 p-3 sm:p-4 md:p-6 flex items-center justify-between">
                            <div className="flex items-center gap-3 md:gap-4">
                              <div className="w-11 h-11 md:w-14 md:h-14 rounded-xl md:rounded-2xl bg-primary/10 flex flex-col items-center justify-center">
                                <span className="text-[9px] md:text-xs text-primary/70 uppercase">
                                  Day
                                </span>
                                <span className="text-base md:text-xl font-bold text-primary">
                                  {item.day}
                                </span>
                              </div>
                              <div>
                                <h3 className="font-bold text-slate-900 text-sm md:text-lg mb-1">
                                  {item.title}
                                </h3>
                              </div>
                            </div>
                            {/* Arrow icon */}
                            <svg
                              className={`h-4 w-4 md:h-5 md:w-5 text-slate-400 transition-transform ${
                                isOpen ? "rotate-180" : ""
                              }`}
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path d="m6 9 6 6 6-6" />
                            </svg>
                          </div>
                        </button>
                        {/* Body: show when open */}
                        {isOpen && (
                          <div className="border-t border-slate-100">
                            <div className="relative h-64 sm:h-80">
                              <img
                                src={item.image}
                                alt={item.title}
                                className="absolute inset-0 w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                            </div>
                            <div className="p-5 sm:p-6">
                              <div 
                                className="text-slate-600 mb-5 leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-1"
                                dangerouslySetInnerHTML={{ __html: item.description }}
                              />

                              {/* Meals & Stay */}
                              <div className="flex flex-wrap gap-6 mobile-meals">
                                {/* Meals */}
                                <div className="flex items-center gap-3">
                                  <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5 text-orange-500"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                    >
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M7 2v20" />
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3m0 0v7" />
                                    </svg>
                                  </div>
                                  <div>
                                    <p className="text-xs text-slate-400 uppercase tracking-wide">
                                      Meals
                                    </p>
                                    <p className="text-sm font-medium text-slate-700">
                                      {item.meals}
                                    </p>
                                  </div>
                                </div>

                                {/* Stay */}
                                <div className="flex items-center gap-3">
                                  <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5 text-blue-500"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                    >
                                      <path strokeLinecap="round" strokeLinejoin="round" d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                      <polyline strokeLinecap="round" strokeLinejoin="round" points="9 22 9 12 15 12 15 22" />
                                    </svg>
                                  </div>
                                  <div>
                                    <p className="text-xs text-slate-400 uppercase tracking-wide">
                                      Stay
                                    </p>
                                    <p className="text-sm font-medium text-slate-700">
                                      {item.stay}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          </div>
        </div>
      </div>

      <section className="container py-5">
        <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6">
          What's Included
        </h2>
        <div className="grid sm:grid-cols-2 gap-5 md:gap-8">
          <div>
            <h3 className="font-semibold text-slate-900 mb-3 md:mb-4 flex items-center gap-2 text-sm md:text-base">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check h-4 w-4 md:h-5 md:w-5 text-green-500"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
              Included
            </h3>
            <ul className="space-y-2 md:space-y-3">
            {inclusion.map((place, index) => (
              <li key={index} className="text-slate-600 text-xs md:text-sm flex items-start gap-2">
                <span className="text-green-500 mt-0.5">•</span>{place}
              </li>
            ))}
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-3 md:mb-4 flex items-center gap-2 text-sm md:text-base">
              <span className="w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-slate-300 flex items-center justify-center text-[10px] md:text-xs text-slate-400">
                ✕
              </span>
              Not Included
            </h3>
            <ul className="space-y-2 md:space-y-3">
            {exclusion.map((exclusiondata, index) => (
              <li key={index} className="text-slate-600 text-xs md:text-sm flex items-start gap-2">
                <span className="text-slate-400 mt-0.5">•</span>{exclusiondata}
              </li>
            ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default CommonSection;